sap.ui.requireSync("sap/ui/test/starter/_setupAndStart");
